var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("CronServiceBusDialog", {
        ref: "cronServiceBusDialog",
        on: { closed: _vm.onCronServiceBusDialogClosed },
        model: {
          value: _vm.CronServiceBusDialog,
          callback: function($$v) {
            _vm.CronServiceBusDialog = $$v
          },
          expression: "CronServiceBusDialog"
        }
      }),
      _c(
        "div",
        { staticClass: "elevation-1 mb-1 pb-2" },
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("scheduler.schedules")) + " "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-3",
                  attrs: { small: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.openScheduleDialog(null)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
                  _vm._v(" " + _vm._s(_vm.$t("common.addNew")) + " ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-skeleton-loader",
        {
          attrs: {
            loading: _vm.loading,
            "transition-group": "scale-transition",
            type: "table"
          }
        },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.showableHeaders,
              items: _vm.schedules,
              "item-key": "Id",
              "item-class": _vm.transportEventRowClass,
              options: _vm.options,
              searchTotalCount: _vm.searchTotalCount,
              "multi-sort": _vm.multisortEnabled,
              search: _vm.filter,
              loading: _vm.loadingPage,
              "calculate-widths": "",
              "hide-default-footer": true
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item.createdAt",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(item.createdAt)) + " ")
                  ]
                }
              },
              {
                key: "item.cronTickerCustomName",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "truncate-name",
                        attrs: {
                          title: item.customProperties.CronTickerCustomName
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(item.customProperties.CronTickerCustomName) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.edit",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-3",
                            attrs: { small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.openScheduleDialog(item)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("mdi-cog")
                            ]),
                            _vm._v(" " + _vm._s(_vm.$t("common.edit")) + " ")
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-3",
                            attrs: { small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.deleteSchedule(item.id)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("mdi-delete")
                            ]),
                            _vm._v(" " + _vm._s(_vm.$t("common.delete")) + " ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbarColor },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
          _c(
            "v-btn",
            {
              attrs: { text: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }